import { render, staticRenderFns } from "./ProjectSelected.vue?vue&type=template&id=785a5dae&scoped=true"
import script from "./ProjectSelected.vue?vue&type=script&lang=ts"
export * from "./ProjectSelected.vue?vue&type=script&lang=ts"
import style0 from "./ProjectSelected.vue?vue&type=style&index=0&id=785a5dae&prod&lang=css"
import style1 from "./ProjectSelected.vue?vue&type=style&index=1&id=785a5dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a5dae",
  null
  
)

export default component.exports